import React  from "react";
import { useParams } from 'react-router-dom';
import ScheduleForm from "./components/ScheduleForm";
import Card from "components/card";

const EditEmployeeSetting = () => {

    const { employeeId, scheduleId } = useParams();

    return (
        <Card extra={"w-full h-full p-4"}>
            <div className="mt-5 grid h-full grid-cols-1 gap-4">
                <ScheduleForm employeeId={employeeId} recordId={scheduleId} mode="edit"/>
            </div>
        </Card>
    );
};

export default EditEmployeeSetting;